export default "__VITE_ASSET__b15341ce__"